const errorCodes = {
  AUTHENTICATION_USER_NOT_FOUND: 1000_0001,
};

export default errorCodes;
